import { useRouteMatch } from 'react-router-dom';
const useFlowId = () => {
  const match = useRouteMatch(['/platform/flow/:flowId', '/details/:flowId', '/embedded-configs/:flowId']);
  if (!match) return null;
  const flowId = Number(match.params.flowId);
  return !isNaN(flowId) ? flowId : null;
};
export default useFlowId;